import React from 'react';
import PropTypes from 'prop-types';

const BookingWorkflowRenderer = (props) => {
  return (
    <div className="tw-text-blue-600">{props.value}</div>
  );
};

BookingWorkflowRenderer.propTypes = {
  value: PropTypes.node
};

export default BookingWorkflowRenderer;
